<template>
  <div id="ping">
    <Header :headerTitle="$t('m.complaint.title')" :hasBackBtn="true"></Header>
    <section>
      <textarea maxlength="200" :placeholder="$t('m.complaint.contextpaceholder')" v-model="complaintMemo" @input="text"></textarea>
      <p>
        <span>{{count}}</span>/
        <span>200</span>
      </p>
    </section>
    <footer>
      <b-button href="#" :disabled="complaintMemo==''">
        <span style="display: block;" @click="saveComplaint()">{{$t('m.complaint.button')}}</span>
      </b-button>
      <!-- <button @click="saveComplaint">保存</button> -->
    </footer>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { complaintByOrderId } from "../../api/complaint.js";
export default {
  name: "complaint",
  data() {
    return {
      complaintMemo: "", //投诉内容
      orderId: "", //订单Id
      count: 0, //字
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    text: function() {
      this.count = this.complaintMemo.length;
    },
    saveComplaint: function() {
      complaintByOrderId({
        orderId: this.orderId,
        complaintMemo: this.complaintMemo
      }).then(
        response => {
          if (response.data.status == 200) {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = this.$t('m.complaint.saveMessage');
            this.tipType = "success";
            setTimeout(_ => {
              window.history.back();
            }, 1100);
          } else {
            this.message = response.data.message;
            this.tipShow = "1" + Math.random() * 1000;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  created() {
    this.orderId = this.$route.params.orderId; //订单Id
  }
};
</script>
<style scoped>
#ping {
  height: 100%;
  background-color: #f5f5f5;
}
section {
  margin: 15px 0 40px 0;
}
section textarea {
  height: 150px;
  border-radius: 0px;
  border: 0px;
  width: 100%;
}
section p {
  text-align: right;
  margin-top: -30px;
  margin-right: 3px;
}
footer a {
  width: 90%;
  color: #fff;
  background-color: #0066B1;
  border: 0px;
  line-height: 45px;
  border-radius: 4px;
}
</style>
  
  
  